<template>
  <div class="mb-5" style="background-color: var(--color-light-light-gray); padding: 20px">
    <h4 class="h5 fw-bold mb-4">
      {{ $t("project.previewAndReport.projectInfo.title") }}
    </h4>
    <div class="row">
      <!-- Description -->
      <div class="mb-1">
        <p class="mb-1">
          <strong
            >{{
              $t("project.previewAndReport.projectInfo.description")
            }}: </strong
          >
          <span v-html="
            $t(
              `project.previewAndReport.reportTypes.complete_solution.installment.projectInfo.description`,
              {
                phase: `<span style='color: var(--description-color);'>${$t(`project.previewAndReport.phaseTypes.${projectData?.phase_type||'single'}`)}</span>`,
                power: `<span style='color: var(--description-color);'>${projectData?.total_power || '0'}</span>`,
                battery: `<span style='color: var(--description-color);'>${projectData?.total_battery || '0'}</span>`,
              }
            )
          "></span>
        </p>
      </div>

      <!-- Left Column -->
      <div class="col-md-6">
        <div class="mb-1">
          <strong
            >{{
              $t("project.previewAndReport.projectInfo.clientName")
            }}: </strong
          >
          <span style="color: var(--description-color);">{{ projectData?.client_name || "N/A" }}</span>
        </div>
        <div class="mb-1">
          <strong
            >{{
              $t("project.previewAndReport.projectInfo.totalPower")
            }}: </strong
          >
          <span style="color: var(--description-color);"> {{ projectData?.total_power || "0" }}</span> kW
        </div>
        <div class="mb-1">
          <strong
            >{{
              $t("project.previewAndReport.projectInfo.annualProduction")
            }}: </strong
          >
          <span style="color: var(--description-color);">{{
            new Intl.NumberFormat("en-EU", {}).format(
              projectData?.annual_production || 0
            )
          }}</span>
          kWh
        </div>
      </div>

      <!-- Right Column -->
      <div class="col-md-6">
        <div class="mb-1">
          <strong
            >{{ $t("project.previewAndReport.projectInfo.address") }}: </strong
          >
          <span style="color: var(--description-color);">{{ projectAddress }}</span>
        </div>
        <div class="mb-1">
          <strong
            >{{
              $t("project.previewAndReport.projectInfo.totalBattery")
            }}: </strong
          >
          <span style="color: var(--description-color);">{{ projectData?.total_battery || "0" }}</span> kWh
        </div>
      </div>
    </div>
    
    <!-- Project Note -->
    <div class="mt-1" v-if="projectData?.note">
      <small
        style="font-size: 10.2px; line-height: 1.2; display: block"
      >
        <strong>{{ $t("project.previewAndReport.projectInfo.note") }}:</strong> {{ projectData.note }}
      </small>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed, PropType } from "vue";
import type { Project } from "@/types/projectTypes";

export default defineComponent({
  name: "ProjectInfoSection",
  props: {
    projectData: {
      type: Object as PropType<Project | null>,
      required: true,
    },
  },
  setup(props) {
    const projectAddress = computed(() => {
      if (!props.projectData) return "N/A";
      const { address, city, country } = props.projectData;
      return [address, city, country].filter(Boolean).join(", ");
    });

    return {
      projectAddress,
    };
  },
});
</script>
